module.exports = __webpack_public_path__ + "img/self_publisher.10d5772f.svg";